<template>
  <v-card class="cashback-expiration-container">
    <h1>Expiração do cashback</h1>
    <mf-tabs-button v-model="expirationType" :buttons="buttons" />
    <div v-if="expirationType === 'AT_PURCHASE'" class="cashback-expiration-config">
      <div class="expiration-description">
        Com essa opção selecionada, o cashback de cada consumidor expira em uma data variável. O cashback irá expirar
        <span class="days-label"> {{ expirationInDaysComputed }} {{ expirationInDaysComputed === 1 ? 'dia' : 'dias' }}</span>
        após a data da compra.
      </div>
      <div class="expiration-in-days">
        <mf-tooltip top :disabled="endDate.length !== 0" max-width="200">
          <template #activator="{ on }">
            <mf-number-input
              v-model="expirationInDaysComputed"
              dense
              outlined
              auto-format
              label="Expiração em dias"
              show-arrows
              :min="1"
              :error="!!inputErrorMessage.length"
              :error-messages="inputErrorMessage"
              :value="expirationInDaysComputed"
              :disabled="endDate.length === 0"
            />
          </template>
          <span>A expiração de cashback só pode ser configurada após a configuração da data final da campanha.</span>
        </mf-tooltip>
      </div>
    </div>
    <div v-else class="cashback-expiration-config">
      <div class="expiration-description">
        Com essa opção selecionada, o cashback distribuído nessa campanha expira na mesma data para todos os consumidores.
      </div>
      <div class="expiration-date">
        <mf-tooltip top :disabled="endDate.length !== 0" max-width="200">
          <template #activator="{ on }">
            <date-select
              v-model="expireDateComputed"
              :value="expireDateComputed"
              dense
              type="date"
              label="Data de expiração"
              :min="minExpirationDate"
              :error="!!inputErrorMessage.length"
              :error-messages="inputErrorMessage"
              :disabled="endDate.length === 0"
              hide-action-buttons
            />
          </template>
          <span>A expiração de cashback só pode ser configurada após a configuração da data final da campanha.</span>
        </mf-tooltip>
      </div>
    </div>
  </v-card>
</template>
<script>
import { DateTime } from 'luxon'

export default {
  name: 'CashbackExpirationDate',
  components: {
    DateSelect: () => import('@/components/DateSelect.vue'),
  },
  props: {
    type: {
      type: String,
      default: 'AT_PURCHASE',
    },
    inputErrorMessage: {
      type: String,
      default: '',
    },
    minDate: {
      type: String,
      default: '',
    },
    expirationInDays: {
      type: Number,
      default: 1,
    },
    expireDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    expirationType: {
      get() {
        return this.type
      },
      set(value) {
        this.$emit('update:type', value)
      },
    },
    expirationInDaysComputed: {
      get() {
        return this.expirationInDays
      },
      set(value) {
        this.$emit('update:expirationInDays', value)
      },
    },
    expireDateComputed: {
      get() {
        if (this.expireDate.length > 0) {
          return DateTime.fromISO(this.expireDate).isValid
            ? this.expireDate
            : DateTime.fromFormat(this.expireDate, 'yyyy-MM-dd HH:mm:ss').toFormat('yyyy-MM-dd')
        } else {
          return this.expireDate
        }
      },
      set(value) {
        this.$emit('update:expireDate', value)
      },
    },
    minExpirationDate() {
      return DateTime.fromISO(this.endDate).plus({ days: 1 }).toFormat('yyyy-MM-dd')
    },
    buttons() {
      return [
        {
          id: '0',
          label: 'Data variável',
          value: 'AT_PURCHASE',
          active: true,
        },
        {
          id: 1,
          label: 'Data fixa',
          value: 'BY_DATE',
          active: true,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.cashback-expiration-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px 24px 20px;
  h1 {
    color: $cinza-d20;
    font-size: 20px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 0.4px;
  }
  .cashback-expiration-config {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: -10px;
    .expiration-in-days {
      max-width: 168px;
    }
    .expiration-date {
      max-width: 212px;
    }
    .expiration-description {
      max-width: 556px;
      color: $cinza-0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      .days-label {
        color: $marca-1;
        font-weight: 700;
      }
    }
  }
}
</style>
